import CopyrightInput from '@/components/common/CopyrightInput';
import FormGroupWithTooltip from '@/components/common/FormGroup/FormGroupWithTooltip';
import { buildPhonographicCopyrightLine } from '@/components/common/ProductUtilities';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TrackEditViewTemplateProps } from '../TrackEditViewTemplate';
import { BaseFormGroupProps } from './types';

type Props = Pick<
  TrackEditViewTemplateProps,
  | 'trackData'
  | 'baseMixedTrack'
  | 'handleInput'
  | 'fieldHasErrors'
  | 'fieldValidationState'
  | 'findErrorMessage'
  | 'isMultipleTrack'
  | 'areNewMultipleTracks'
> &
  BaseFormGroupProps;

export default function TrackPhonographicCopyrightYearFormGroup({
  trackData,
  baseMixedTrack,
  readonly,
  disabled,
  handleInput,
  fieldHasErrors,
  fieldValidationState,
  findErrorMessage,
  isMultipleTrack,
  areNewMultipleTracks,
}: Props) {
  const { t } = useTranslation();

  return (
    <FormGroupWithTooltip
      tooltipKey="tooltip.track.pLine"
      hasErrors={
        (!isMultipleTrack && fieldHasErrors('PhonographicCopyrightYear')) ||
        (!isMultipleTrack && fieldHasErrors('PhonographicCopyrightLine'))
      }
    >
      <CopyrightInput
        id={'trackPhonographicCopyrightYear'}
        labelText={t('product.editProduct.pline')}
        year={
          !isMultipleTrack
            ? trackData.phonographicCopyrightYear
            : (baseMixedTrack?.phonographicCopyrightYear?.value as number)
        }
        originalYear={
          baseMixedTrack?.phonographicCopyrightYear?.originalValue as number
        }
        onYearChange={(year) => handleInput('phonographicCopyrightYear', year)}
        linePlaceholderLabelText={t('product.editProduct.copyright_owner')}
        line={
          !isMultipleTrack
            ? trackData.phonographicCopyrightLine
            : (baseMixedTrack?.phonographicCopyrightLine?.value as string)
        }
        originalLine={baseMixedTrack?.phonographicCopyrightLine}
        onLineChange={(line) => handleInput('phonographicCopyrightLine', line)}
        yearErrorMessage={
          fieldHasErrors('PhonographicCopyrightYear') && !isMultipleTrack
            ? findErrorMessage('PhonographicCopyrightYear')
            : undefined
        }
        yearValidationState={
          !isMultipleTrack
            ? fieldValidationState?.('PhonographicCopyrightYear')
            : undefined
        }
        lineErrorMessage={
          fieldHasErrors('PhonographicCopyrightLine') && !isMultipleTrack
            ? findErrorMessage('PhonographicCopyrightLine')
            : undefined
        }
        lineValidationState={
          !isMultipleTrack
            ? fieldValidationState?.('PhonographicCopyrightLine')
            : undefined
        }
        displayLineBuilder={buildPhonographicCopyrightLine}
        readonly={readonly}
        disabled={disabled}
        labelClassName="col-sm-3 form-label"
        inputPairClassName="col-sm-6 pair-input-container padding-left-0"
        errorMessageClassName="col-sm-2 popUp-container"
        multiTrack={isMultipleTrack}
        showChangeIndicator={!areNewMultipleTracks}
      />
    </FormGroupWithTooltip>
  );
}
